module.exports = __webpack_public_path__ + "img/CL2_7765.f5e99c4d.jpg";